// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScaleComp_wrapper__2MZuR"};